import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {LoginContextProvider} from '../../components/LoginContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import FieldUsername from '../../components/FieldUsername';
import FieldPassword from '../../components/FieldPassword';
import ButtonLink from '../../components/ButtonLink';
import ButtonLogin from '../../components/ButtonLogin';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import {pathnames as P} from '../../../../common/enums/pathnames';
import styles from './Login.module.scss';

const Login = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'login-page-header'}
        defaultMessage={'Login'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <LoginContextProvider>
      <SectionPanel className={styles.loginContainer}>
        <FieldUsername/>
        <FieldPassword/>
        <ButtonLink
          link={P.FORGOT_PASSWORD}
          label={
            <FormattedMessage
              id={'login-button-forgot-password'}
              defaultMessage={'Forgot password'}
            />
          }
          customClassnames={styles.forgotPasswordLink}
        />
        <ButtonLogin/>
        <ButtonLink
          link={P.LOGIN_BY_PHONE}
          label={
            <FormattedMessage
              id={'login-button-login-by-phone'}
              defaultMessage={'Login via SMS'}
            />
          }
        />
        <ButtonLink
          link={P.REGISTER}
          label={
            <FormattedMessage
              id={'login-button-register'}
              defaultMessage={'Not registered? Register here'}
            />
          }
          customClassnames={styles.registerLink}
        />
      </SectionPanel>
      <FooterLogo/>
    </LoginContextProvider>
  );
};

export default Login;
